import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => {
  return {
    collapseButton: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      color: "#475467",
      gap: "4px",
      cursor: "pointer",
      marginTop: "12px",
      "& span": {
        fontFamily: "Manrope",
        fontWeight: 500,
        fontSize: "14px",
      },
      "& svg": {
        color: "#475467",
      },
    },
    screenshotList: {
      height: "calc(100vh - 150px)",
      marginTop: "10px",
      overflowY: "auto",
      overflowX: "hidden",
      "&::-webkit-scrollbar": {
        width: "6px",
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#EDF5FB",
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#465869",
        borderRadius: "8px",
      },
    },
    screenshot: {
      height: "75px",
      width: "98px",
      borderRadius: "8px",
      cursor: "pointer",
      marginRight: "4px",
    },
    screenshotSkeleton: {
      width: "98px",
      borderRadius: "8px",
      cursor: "pointer",
      marginRight: "4px",
    },
  };
});

export default styles;
